import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { getAssetSrc } from '@restworld/utils-common';
import { Title, Button } from '../../';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ModalMessage(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      closeButtonTitle = _ref.closeButtonTitle,
      onCloseCallback = _ref.onCloseCallback,
      redirectBtnTitle = _ref.redirectBtnTitle,
      onRedirectCallback = _ref.onRedirectCallback,
      _ref$iconSrc = _ref.iconSrc,
      iconSrc = _ref$iconSrc === void 0 ? getAssetSrc('/utils-assets/green-check-mark.svg') : _ref$iconSrc,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(Wrapper, {
    textAlign: textAlign,
    children: [!!iconSrc && typeof iconSrc === 'string' ? /*#__PURE__*/_jsx(_StyledImg, {
      src: iconSrc,
      alt: ""
    }) : iconSrc, /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsx(Title, {
          isCenter: textAlign === 'center',
          fontSize: "superLarge",
          content: title,
          fontWeight: "bold"
        }), !!subTitle && /*#__PURE__*/_jsx(Title, {
          isCenter: textAlign === 'center',
          content: subTitle,
          textColor: "gray",
          fontSize: "base",
          fontWeight: "light"
        })]
      }), children, Boolean(redirectBtnTitle || closeButtonTitle) && /*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [!!redirectBtnTitle && /*#__PURE__*/_jsx(Button, {
          title: redirectBtnTitle,
          variant: "normal",
          onClick: function onClick(e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            !!onRedirectCallback && onRedirectCallback();
          },
          fullwidth: true
        }), !!closeButtonTitle && /*#__PURE__*/_jsx(ButtonOutLineStyled, {
          title: closeButtonTitle,
          onClick: onCloseCallback,
          variant: "secondary-outline",
          fullwidth: true
        })]
      })]
    })]
  });
}
export default ModalMessage;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-message__Wrapper",
  componentId: "sc-1agjn4e-0"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem",
  "paddingBottom": "1rem"
}, function (_ref2) {
  var textAlign = _ref2.textAlign;
  return textAlign === 'center' ? {
    "textAlign": "center"
  } : {
    "textAlign": "start"
  };
});

var ButtonOutLineStyled = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(Button, _objectSpread({}, props));
}).withConfig({
  displayName: "modal-message__ButtonOutLineStyled",
  componentId: "sc-1agjn4e-1"
})(["", ";"], {
  "width": "100%"
});

var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "modal-message___StyledImg",
  componentId: "sc-1agjn4e-2"
})({
  "marginLeft": "auto",
  "marginRight": "auto",
  "height": "2rem",
  "width": "2rem"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-message___StyledDiv",
  componentId: "sc-1agjn4e-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "3.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-message___StyledDiv2",
  componentId: "sc-1agjn4e-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modal-message___StyledDiv3",
  componentId: "sc-1agjn4e-5"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem"
});